import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient) {}

  refreshToken(): Observable<void> {
    const httpOptions = {
      withCredentials: true,
    };

    return this.http.get<void>(
      `${environment.apiAuthenticate}/refresh-token`,
      httpOptions
    );
  }

  validateToken(): Observable<boolean> {
    const httpOptions = {
      withCredentials: true,
    };

    return this.http.get<boolean>(
      `${environment.apiAuthenticate}/validate-token`,
      httpOptions
    );
  }
}
